// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/footer.css';

/* SVG iconos monocolor — se pintan con fill:#1C3A1E */
const IgIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.334 3.608 1.308.975.975 1.246 2.242 1.308 3.608.058 1.266.069 1.646.069 4.851s-.011 3.584-.069 4.85c-.062 1.366-.333 2.633-1.308 3.608-.975.975-2.242 1.246-3.608 1.308-1.266.058-1.646.069-4.85.069s-3.584-.011-4.85-.069c-1.366-.062-2.633-.333-3.608-1.308-.975-.975-1.246-2.242-1.308-3.608C2.175 15.584 2.163 15.204 2.163 12s.012-3.584.07-4.85c.062-1.366.334-2.633 1.308-3.608C4.516 2.497 5.783 2.225 7.15 2.163 8.416 2.105 8.796 2.163 12 2.163zm0-2.163C8.741 0 8.332.014 7.052.072 5.197.157 3.355.673 2.014 2.014.673 3.355.157 5.197.072 7.052.014 8.332 0 8.741 0 12c0 3.259.014 3.668.072 4.948.085 1.855.601 3.697 1.942 5.038 1.341 1.341 3.183 1.857 5.038 1.942C8.332 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 1.855-.085 3.697-.601 5.038-1.942 1.341-1.341 1.857-3.183 1.942-5.038.058-1.28.072-1.689.072-4.948 0-3.259-.014-3.668-.072-4.948-.085-1.855-.601-3.697-1.942-5.038C20.645.673 18.803.157 16.948.072 15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zm0 10.162a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/>
  </svg>
);

const FbIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.235 2.686.235v2.97h-1.513c-1.491 0-1.956.93-1.956 1.886v2.269h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"/>
  </svg>
);

const WaIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>
  </svg>
);

const PinIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
  </svg>
);

const MailIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
  </svg>
);

const MsgIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/>
  </svg>
);

/* Icono hoja para categorías */
const LeafIcon = () => (
  <svg className="cat-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 8C8 10 5.9 16.17 3.82 21.34L5.71 22l1-2.3A4.49 4.49 0 0 0 8 20C19 20 22 3 22 3c-1 2-8 2-11 5 3-2 7.5-1.5 9-1-2 2-6 4-9 4 2-1 4.5-2 6-4-3 2-6.5 3.5-8 5 1.5-1.5 4-3 5.5-4.5C10 12 7.5 14 6 15.5c1-2 3-4 5-5.5C8 12 5.5 15 4.5 17.5 6 14 9 11.5 12 10c-2 2-4 5-5 7.5 1.5-3 4-5.5 7-7C11 13 9 16 8 18c1.5-2.5 4-5 7-6-2 2-3 4-4 6.5 1-2.5 3-5 5.5-6.5z"/>
  </svg>
);

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">

          {/* Brand */}
          <div className="footer-brand">
            <div className="footer-logo">
              <img src="https://res.cloudinary.com/dcbd2vdzn/image/upload/v1777340903/logo_wawita2_tge5t4.png" alt="Wawita Eco Friendly"
                style={{ height:80, width:80, objectFit:'contain', borderRadius:'50%' }} />
            </div>
            <p className="footer-description">
              Productos naturales de aseo personal para toda la familia. Cuidamos de ti y del planeta con cada producto que fabricamos en Pasto, Colombia.
            </p>
            <div className="social-links">
              <a href="https://instagram.com/wawitaeco" target="_blank" rel="noreferrer" className="social-link">
                <IgIcon /> Instagram
              </a>
              <a href="https://facebook.com/wawitaecologico1" target="_blank" rel="noreferrer" className="social-link">
                <FbIcon /> Facebook
              </a>
              <a href="https://wa.me/573113407979" target="_blank" rel="noreferrer" className="social-link">
                <WaIcon /> WhatsApp
              </a>
            </div>
          </div>

          {/* Productos */}
          <div className="footer-section">
            <h4>Productos</h4>
            <ul className="footer-links">
              <li><Link to="/?cat=cat-1"><LeafIcon /> Cuidado personal</Link></li>
              <li><Link to="/?cat=cat-2"><LeafIcon /> Bebés y niños</Link></li>
              <li><Link to="/?cat=cat-3"><LeafIcon /> Cabello</Link></li>
              <li><Link to="/?cat=cat-4"><LeafIcon /> Maquillaje eco</Link></li>
              <li><Link to="/?cat=cat-5"><LeafIcon /> Ropa sostenible</Link></li>
              <li><Link to="/?cat=cat-6"><LeafIcon /> Mascotas</Link></li>
            </ul>
          </div>

          {/* Información */}
          <div className="footer-section">
            <h4>Información</h4>
            <ul className="footer-links">
              <li><Link to="/nuestra-historia">Nuestra historia</Link></li>
              <li><Link to="/compromiso-ambiental">Compromiso ambiental</Link></li>
              <li><Link to="/sistema-refill">Sistema de Refill</Link></li>
              <li><Link to="/noticias">Noticias</Link></li>
              <li><Link to="/mi-cuenta">Mi cuenta / Pedidos</Link></li>
              <li><Link to="/carrito">Mi carrito</Link></li>
              <li><Link to="/privacidad">Politica de privacidad</Link></li>
              <li><Link to="/terminos">Terminos y condiciones</Link></li>
            </ul>
          </div>

          {/* Contacto */}
          <div className="footer-section">
            <h4>Contacto</h4>
            <ul className="footer-contact">
              <li>
                <PinIcon className="contact-icon" />
                <span>Pasto, Nariño, Colombia</span>
              </li>
              <li>
                <MailIcon className="contact-icon" />
                <span>contacto@wawitaeco.com</span>
              </li>
              <li>
                <MsgIcon className="contact-icon" />
                <span>+57 311 340 7979</span>
              </li>
            </ul>
            <Link to="/contacto" style={{
              display:'inline-block', marginTop:12, padding:'8px 20px',
              background:'rgba(28,58,30,0.12)', color:'#1C3A1E',
              border:'1.5px solid rgba(28,58,30,0.3)',
              borderRadius:8, fontWeight:700, textDecoration:'none', fontSize:13,
              transition:'all 0.2s'
            }}>
              Envíanos un mensaje
            </Link>
          </div>
        </div>

        <div className="footer-bottom">
          <div>© {new Date().getFullYear()} Wawita Eco Friendly · Todos los derechos reservados</div>
          <div className="footer-badges">
            <span className="footer-badge">🌿 100% Natural</span>
            <span className="footer-badge">♻️ Eco packaging</span>
            <span className="footer-badge">🇨🇴 Hecho en Colombia</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
